<form #activityForm="ngForm" class="p-2 cobtainer-capped-sm kp-spinner-container-lg" *ngIf="activity"
  [style.min-width]="Utility.mobile? undefined : '500px'">
  <ngx-spinner name="loading" [fullScreen]="false" type="timer"></ngx-spinner>

  <!-- <h5 *ngIf="isNew">{{!activity.Id?'ثبت':'ویرایش'}} {{!activity.IsDone?'وظیفه':'یادداشت'}}</h5> -->
  <!-- <label *ngIf="!isNew" class="d-flex align-items-center">
    <div class="flex-fill">
      <h6 class="mb-0" [class.f-gray]="activity.IsDone" *ngIf="!isAdmin && activity.CreatorId!=current.Id">
        {{activity.Title}}
      </h6>
    </div>
  </label> -->
  <div class="d-flex align-items-center">

    <div class="badge badge-light border p-0 fs-sm" [ngSwitch]="activity.Key">
      <div class="violet-bg f-white p-1" *ngSwitchCase="'seeker-call'"><i class="fa fa-user ml-1"></i>کارجو</div>
      <div class="violet-bg f-white p-1" *ngSwitchCase="'seeker-call-failed'"><i class="fa fa-user ml-1"></i>کارجو</div>
      <div class="service-bg f-white p-1" *ngSwitchCase="'job-call'"><i class="fa fa-building ml-1"></i>کارفرما</div>
      <div class="service-bg f-white p-1" *ngSwitchCase="'job-call-failed'"><i class="fa fa-building ml-1"></i>کارفرما
      </div>
    </div>

    <h6 class="mb-0 mr-2">{{activity.Title}}</h6>
  </div>

  <div *ngIf="isNew ? !activity.IsDone : (isCreator && activity.Note); else noteHtml">
    <h6>توضیحات</h6>
    <ng-container *ngIf="!edit.Note">
      <div [innerHTML]="activity.Note"></div>
      <div (click)="edit.Note=true">ویرایش</div>
    </ng-container>
    <angular-editor *ngIf="edit.Note" name="note" [(ngModel)]="activity.Note" [config]="Common.EditotConfig_User">
    </angular-editor>
    <!-- <textarea *ngIf="edit.Note" rows="5" [(ngModel)]="activity.Note" name="note" required autofocus></textarea> -->
  </div>
  <ng-template #noteHtml>
    <div *ngIf="activity.Note" [innerHTML]="activity.Note"></div>
  </ng-template>

  <div *ngIf="isNew ? activity.IsDone : isOperator; else resultNoteHtml">
    <h6>نتیجه</h6>
    <angular-editor name="reasultNote" [(ngModel)]="activity.ResultNote" [config]="Common.EditotConfig_User">
    </angular-editor>
    <!-- <textarea rows="5" [(ngModel)]="activity.ResultNote" name="reasultNote" autofocus></textarea> -->
  </div>
  <ng-template #resultNoteHtml>
    <div *ngIf="activity.ResultNote" [innerHTML]="activity.ResultNote"></div>
  </ng-template>
  <div *ngIf="!activity.IsDone && (isNew || isCreator || isOperator)">
    <label class="d-flex">
      <strong>کاربر: </strong>
      <ng-container *ngIf="!edit.Operator">
        {{activity.Operator?.name || activity.Operator?.username}}
        <i class="fa fa-edit pointer" (click)="edit.Operator=true"></i>
      </ng-container>
      <div class="mr-1">
        <select *ngIf="edit.Operator" [(ngModel)]="activity.OperatorId" name="operatorId">
          <option *ngFor="let item of operators" [ngValue]="item.Id">{{item.Name || item.Username}}</option>
        </select>
      </div>
    </label>

    <label class="d-flex">
      <strong>زمان انجام:</strong>
      <ng-container *ngIf="!edit.DueDate">
        {{activity.DueDate|pdate}}
        <i class="fa fa-edit pointer" (click)="edit.DueDate=true"></i>
      </ng-container>
      <app-calendar *ngIf="edit.DueDate" name="duedate" required [(ngModel)]="activity.DueDate"
        mode="year-month-day-time" shortcuts="next15min,nexthour,next3hour,evening,tomorrowmorning,tomorrowevening">
      </app-calendar>
    </label>
  </div>

  <div *ngIf="!isNew && activity.IsDone">
    <h6>کاربر</h6>
    {{activity.Operator?.name || activity.Operator?.username}}
    <h6>زمان انجام</h6>
    {{activity.DoneDate|pdate}}
  </div>

  <div class="p-1">
    <div *ngIf="isNew ? activity.IsDone : (!activity.IsDone && isOperator)">
      <label>
        <input type="checkbox" [(ngModel)]="addAnother" name="addAnother" />
        آیا پس از ثبت نتیجه نیاز به ایجاد یک وظیفه پیگیری در آینده دارید؟
      </label>
    </div>

    <button *ngIf="isNew ? !activity.IsDone : (isCreator || isOperator)" class="btn mx-1" [class.btn-primary]="isNew"
      [class.btn-secondary]="!isNew" (click)="Utility.validate(activityForm) && save()">ذخیره</button>

    <button *ngIf="(isNew ? activity.IsDone : !activity.IsDone) && isOperator" class="btn btn-green mx-1"
      (click)="Utility.validate(activityForm) && save(true)">
      <div class="d-flex flex-column">
        <div>ثبت نتیجه</div>
        <div *ngIf="addAnother" class="fs-xs">+ایجاد وظیفه پیگیری</div>
      </div>
    </button>

    <button class="btn btn-red mx-1" *ngIf="!isNew && isCreator" (confirm)="remove()">حذف</button>
  </div>
</form>